// Webrtc plugin.
import pluginInterface from './interface'
import events from './interface/events'
import watchManagers from './channels'
import * as sagas from './sagas'
import { miscActions } from './interface/actions'

// Other plugins.
import { mapEvents } from '../events/interface/actions'
import { logManager } from '../logs'

// Helpers.
import { autoRestart } from '../common/utils'

// Libraries.
import initialize, { getWebRTCSupportCapabilities } from 'kandy-webrtc'
import { values } from 'lodash/fp'
import { call, fork, put } from 'redux-saga/effects'

const log = logManager.getLogger('WEBRTC')

export function initializeStack () {
  return initialize()
}

export default function webRtcPlugin () {
  const { mediaDevices, peerConnection } = getWebRTCSupportCapabilities()
  if (!mediaDevices || !peerConnection) {
    log.warn(
      'Calls are not supported on this platform due to lack of WebRTC support. Media APIs will not be available.'
    )
    return
  }

  // Initialize the webRTC.
  const webRTC = initialize()

  function * init ({ webRTC }) {
    yield put(mapEvents(events))

    // Wrap the webrtc sagas in a function that provides them with the webRTC stack.
    const wrappedSagas = values(sagas).map(saga => {
      return autoRestart(() => saga(webRTC.managers))
    })

    // Run all of the sagas.
    for (const saga of wrappedSagas) {
      yield fork(saga)
    }

    // Watch for events from the webRTC stack.
    // TODO: Don't also pass in the entire stack.
    yield fork(watchManagers, webRTC.managers, webRTC)

    // Use the webRTC stack to check the browser details.
    const details = yield call([webRTC, 'getBrowserDetails'])
    log.info(`Browser details: ${details.browser}, version ${details.version}.`)
    yield put(miscActions.setBrowserDetails(details))
  }

  return {
    name: pluginInterface.name,
    api: pluginInterface.api,
    reducer: pluginInterface.reducer,
    init,
    shared: {
      webRTC
    }
  }
}
